import React from "react";
import {
    Box,
    Typography,
    Container,
    Grid,
    Paper,
} from "@mui/material";

const ProfessionalSummary = () => {
    return (
        <Box sx={{ backgroundColor: "#f2f2f2", py: 5,px: {xs:"auto",md:20}  }}>
            <Container >
                {/* TITLE + GRADIENT LINE */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 4,
                        gap: 2,
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontFamily: "'Playfair Display', serif !important",
                            fontSize: {xs:"20px",md:"50px"},
                            fontWeight: 600,
                            color: "#0f2e4d",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Professional Summary
                    </Typography>

                    <Box
                        sx={{
                            flex: 1,
                            height: "1px",
                            background:
                                "linear-gradient(to right, #0f63a5, transparent)",
                        }}
                    />
                </Box>

                {/* CARD */}
                <Paper
                    elevation={0}
                    sx={{
                        backgroundColor: "#f7f7f7",
                        borderRadius: "12px",
                        p: 4,
                        borderLeft: "6px solid #0f63a5",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                    }}
                >
                    {/* DESCRIPTION */}
                    <Typography
                        variant="body2"
                        sx={{
                            fontSize: "15px",
                            lineHeight: 1.9,
                            color: "#333",
                            mb: 4,
                            textAlign: "left",
                            fontFamily: "'Lato', sans-serif !important",
                        }}
                    >
                        I am a{" "}
                        <Box component="span" sx={{ fontWeight: 600 }}>
                            Luxury Sales Coach, Real Estate Consultant, and Licensed Realtor
                        </Box>{" "}
                        with over{" "}
                        <Box component="span" sx={{ fontWeight: 600 }}>
                            15 years of leadership experience
                        </Box>{" "}
                        in Hyderabad's luxury and ultra-luxury real estate market. A
                        seasoned sales expert specializing in consultative selling,
                        behavioral psychology, and transformational coaching.
                    </Typography>

                    <Grid container spacing={6}>
                        {/* LEFT COLUMN */}
                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                <Box
                                    sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        backgroundColor: "#0f63a5",
                                        mr: 1.5,
                                    }}
                                />
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        color: "#0f2e4d",
                                        fontFamily: "'Playfair Display', serif !important",

                                    }}
                                >
                                    Key Achievements
                                </Typography>
                            </Box>

                            <Box component="ul" sx={{ pl:2, m: 0 }}>
                                {[
                                    "₹2500+ Cr revenue generated via luxury sales",
                                    "1000+ sales professionals trained",
                                    "100s of aspiring realtors mentored",
                                    "Serves top 0.01% UHNWIs with discretion",
                                ].map((item, index) => (
                                    <Typography
                                    
                                        component="li"
                                        key={index}
                                        sx={{
                                         fontFamily: "'Lato', sans-serif !important",
                                             fontSize: "14px !important",
                                            color: "#444",
                                            lineHeight: 1.8,
                                            mb: 0.8,
                                            listStyleType: "disc",
                                            paddingLeft: "5px",
                                            margin: 0,
                                            "& li::marker": {
                                                color: "#000",
                                            },
                                            textAlign:'start'
                                        }}
                                    >
                                        {item}
                                    </Typography>
                                ))}
                            </Box>
                        </Grid>

                        {/* RIGHT COLUMN */}
                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                <Box
                                    sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        backgroundColor: "#0f63a5",
                                        mr: 1.5,
                                    }}
                                />
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        color: "#0f2e4d",

                                        fontFamily: "'Playfair Display', serif !important",
                                    }}
                                >
                                    Core Expertise
                                </Typography>
                            </Box>

                            <Box component="ul" sx={{ pl:2, m: 0 }}>
                                {[
                                    "Consultative Selling & Behavioral Psychology",
                                    "Luxury & Uber Luxury Market Specialization",
                                    "NLP,NEPQ, SPIN, NEAT Sales Methodologies",
                                    "Brand Strategy & GTM Implementation",
                                ].map((item, index) => (
                                    <Typography
                                        component="li"
                                        key={index}
                                        sx={{
                                            fontFamily: "'Lato', sans-serif !important",
                                             fontSize: "14px !important",
                                            color: "#444",
                                            lineHeight: 1.8,
                                            mb: 0.8,
                                            listStyleType: "disc",
                                            paddingLeft: "5px",
                                            margin: 0,
                                            "& li::marker": {
                                                color: "#000",
                                            },
                                            textAlign:'start'
                                        }}
                                    >
                                        {item}
                                    </Typography>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </Box>
    );
};

export default ProfessionalSummary;